import { CheckboxFilter } from '@lifebit-ai/lds'
import React from 'react'

import type { Option } from 'modules/types'
import { useGetAssigneesFromImportRequests } from 'services/import-requests/hooks/useGetAssigneesFromImportRequests'

interface ImportRequestAssigneeFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const ImportRequestAssigneeFilter = ({ onApply, onReset }: ImportRequestAssigneeFilterProps) => {
  const assigneesQuery = useGetAssigneesFromImportRequests()

  const assigneeOptions =
    assigneesQuery.data?.data.map(assignee => ({
      label: assignee.email,
      value: assignee._id
    })) ?? []

  const options = [{ label: 'Unassigned', value: 'unassigned' }, ...assigneeOptions]

  return (
    <CheckboxFilter
      label="Assignee"
      loading={assigneesQuery.isLoading}
      onApply={onApply}
      options={options}
      onReset={onReset}
      searchFieldPlaceholder="Search by email"
    />
  )
}
